// Admin Timetable — manage timetables for all departments
import React from 'react';
import Timetable from '../student/Timetable';
export default Timetable;
